import { employeeWorkHistoryService } from "../services/index"
import { EmployeeWorkedSitesForDurationInterface } from "@type/employees.types"
import { useState } from "react"

const useEmployeeWorkedSitesForDuration = () => {
	const [employeeWorkedSitesForDuration, setEmployeeWorkedHistoryForDuration] = useState<
		EmployeeWorkedSitesForDurationInterface[]
	>([])
	const [isEmployeeWorkedSitesForDurationLoading, setIsEmployeeWorkedHistoryForDurationLoading] = useState(false)

	const fetchEmployeeWorkedSitesForDuration = async (employee: string, startDate: string, endDate: string) => {
		try {
			setIsEmployeeWorkedHistoryForDurationLoading(true)
			const { data: employeeWorkedSitesForDurationResponse } =
				await employeeWorkHistoryService.getEmployeeWorkedSitesForDuration(employee, startDate, endDate)
			setEmployeeWorkedHistoryForDuration(employeeWorkedSitesForDurationResponse)
			setIsEmployeeWorkedHistoryForDurationLoading(false)
		} catch {
			setIsEmployeeWorkedHistoryForDurationLoading(false)
		}
	}

	return {
		fetchEmployeeWorkedSitesForDuration,
		employeeWorkedSitesForDuration,
		isEmployeeWorkedSitesForDurationLoading,
	}
}

export default useEmployeeWorkedSitesForDuration
